export default [
  {
    title: "You are expired on one or more topics",
    description: null,
    footer: "Please complete your training.",
    icon: "fas fa-times-circle",
    bgColor: "alert-danger",
    id: "PROGRAM_EXPIRED",
    type: "STATUS"
  },
  {
    title: "You are at risk of expiring on one or more topics",
    description: null,
    footer: "Please complete your training.",
    icon: "fas fa-exclamation-circle",
    bgColor: "alert-warning",
    id: "PROGRAM_RISK_OF_EXPIRY",
    type: "STATUS"
  },
  {
    title: "You are behind schedule.",
    description: null,
    footer: "Please complete your training.",
    icon: "fas fa-exclamation-triangle",
    bgColor: "alert-warning",
    id: "PROGRAM_BEHIND_SCHEDULE",
    type: "STATUS"
  },
  {
    title: "Compressed/Start-up program",
    description: null,
    footer: null,
    icon: "fas fa-compress-arrows-alt",
    bgColor: "alert-info",
    id: "TYPE_COMPRESSED",
    type: "TYPE"
  }
];
